let scrollPosition = 0;

// Reference count for full-screen overlays (Daily Boost spin /
// milestone / restore checkout). While any counted overlay owns the
// lock, plain enableScroll() calls from page code are no-ops — a
// defensive unlock must not rip the lock away beneath a mounted
// overlay and lose the saved position (Codex review).
let overlayLocks = 0;

const restoreScroll = () => {
  const body = document.querySelector('body');

  body.style.removeProperty('overflow');
  body.style.removeProperty('position');
  body.style.removeProperty('top');
  body.style.removeProperty('width');
  window.scrollTo(0, scrollPosition);
};

export const disableScroll = () => {
  const body = document.querySelector('body');
  scrollPosition = window.pageYOffset;
  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollPosition}px`;
  body.style.width = '100%';
};

export const enableScroll = () => {
  if (overlayLocks > 0) return;
  restoreScroll();
};

export const hasOverlayScrollLock = () => overlayLocks > 0;

// Counted lock: the whole overlay chain (spin → milestone → ceremony)
// holds ONE lock; the true position restores only when the last overlay
// releases. Reading pageYOffset while the body is already fixed yields
// 0, so only the first acquire saves.
export const acquireOverlayScrollLock = () => {
  overlayLocks += 1;
  if (overlayLocks === 1) disableScroll();
};

export const releaseOverlayScrollLock = () => {
  overlayLocks = Math.max(0, overlayLocks - 1);
  if (overlayLocks === 0) restoreScroll();
};
